import { createSelector } from '@reduxjs/toolkit';
import { UserAccessRight } from '../../../general/model';
import { CHNodeCheckName, CHNode } from '../../../general/node';
import { RenamingShape } from './reducers/index';
import { RootSelector, getStore } from '../../models/rootSelector';
import {
  getSelectedNodesOutsideCurrentFolderCount,
  getSingleSelectedNode,
} from '../fileManager/selectors/selectors';
import { getRelativeLocation } from '../breadcrumbs/selectors';

export const getRenaming: RootSelector<RenamingShape> = createSelector(getStore, (x) => x.renaming);

export const getIsOpen: RootSelector<boolean> = createSelector(
  getRenaming,
  (renaming) => renaming.isOpen,
);

export const getName: RootSelector<string> = createSelector(
  getRenaming,
  (renaming) => renaming.name,
);

export const getInProgress: RootSelector<boolean> = createSelector(
  getRenaming,
  (renaming) => renaming.inProgress,
);

export const getNode: RootSelector<CHNode | null> = createSelector(
  getRenaming,
  (renaming) => renaming.node,
);
export const canConfirmRename: RootSelector<boolean> = createSelector(
  [getInProgress, getName],
  (inProgress, name) => {
    return !inProgress && CHNodeCheckName(name);
  },
);

export const getIsRenameAvailable = createSelector(
  [getSingleSelectedNode, getRelativeLocation, getSelectedNodesOutsideCurrentFolderCount],
  (node, relativeLocation, outsideCount) => {
    if (!node) {
      return false;
    }
    if (node.is_linked) {
      return false;
    }
    if (!node.perms.includes(UserAccessRight.write)) {
      return false;
    }
    // if (relativeLocation.inCreative) {
    //   return false;
    // }
    if (outsideCount > 0) {
      return false;
    }
    return true;
  },
);
